"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_TIME_ZONES = void 0;
const client_1 = require("@apollo/client");
exports.SEARCH_TIME_ZONES = (0, client_1.gql) `
  query timeZones($q: String!) {
    timeZones(q: $q) {
      aliases
      country {
        code
        name
      }
      name
      offsets
    }
  }
`;
